import React from "react";
import { Container } from "@mui/material";
import { useSearchParams } from "react-router-dom";

import DettagliAziendaDialog from "./DettaglioAziendaDialog";

const DettagliAzienda = () => {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  return (
    <Container maxWidth="lg">
      <DettagliAziendaDialog id={id} setId={(_) => window.history.back()} />
    </Container>
  );
};

export default DettagliAzienda;
